module.exports = __webpack_public_path__ + "static/img/3.2eb6ebb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/3.png
// module id = ElMB
// module chunks = 0